// extracted by mini-css-extract-plugin
module.exports = {"description":"description--JLFb7"};